<template>
  <div class="mm-main-container">
    <div class="box">
    <div class="m-title">{{ $t('WarrantyObject.title') }}</div>
    <div style="margin-top: 20px;">
        <el-form 
            :model="warrantyForm" 
            :rules="rules"
            label-width="88px" 
            label-position="left"
            ref="WarrantyFormRef"
            style="width: 608px;text-align: left;">
            <el-form-item :label="$t('WarrantyObject.userName')" prop="name">
                <el-input v-model="warrantyForm.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('WarrantyObject.email')" prop="email">
                <el-input v-model="warrantyForm.email"></el-input>
            </el-form-item>
            <el-form-item :label="$t('WarrantyObject.phone')" prop="phone">
                <el-input v-model="warrantyForm.phone" class="no-number" type="number"></el-input>
            </el-form-item>
            <el-form-item :label="$t('WarrantyObject.purchaseDate')" prop="purchaseTime">
                <el-date-picker
                    v-model="warrantyForm.purchaseTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 520px"
                    :picker-options="pickerOptions"
                    :placeholder="$t('WarrantyObject.datePlaceHolder')">
                </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('WarrantyObject.purchaseProduct')" prop="product">
                <el-select v-model="warrantyForm.product" style="width: 520px" :placeholder="$t('WarrantyObject.productRequire')">
                    <el-option v-for="item,index in productOptions" :key="index" :label="item.dictLabel" :value="item.dictValue">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('WarrantyObject.purchasePlace')" prop="purchasePlace">
                <el-input v-model="warrantyForm.purchasePlace"></el-input>
                
            </el-form-item>
            <el-form-item :label="$t('WarrantyObject.serialCode')" prop="serialCode">
                <el-input v-model="warrantyForm.serialCode"></el-input>
            </el-form-item>
            
        </el-form>
        <div style="text-align: left; margin-bottom: 10px; font-size: 14px;"><span style="color: red;">*</span>{{$t('WarrantyObject.requireTip')}}</div>
        <div style="text-align: left; margin-top: 20px; margin-bottom: 10px;"> 
            <el-checkbox v-model="warrantItemsChecked">{{$t('WarrantyObject.productWarranty')}} </el-checkbox> 
            <router-link :to="{path:'/warrantyView'}" target="_blank"> {{ $t('WarrantyObject.warrantItems') }}
  </router-link>
        </div>
        <el-button type="primary" class="primary-button-main m-button"  @click="onClickSubmit()">
            {{ $t('CommonObject.submit') }}
        </el-button>
    </div>
    </div>
  </div>
</template>

<script>
export default {
    name:'Warranty',
    data(){
        return{
            warrantyForm:{
                name:'',
                email:'',
                phone:'',
                purchaseTime:'',
                product:'',
                purchasePlace:'',
                serialCode:'',
                
            },
            detlaTime: 30000,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();   //禁用以前的日期，今天不禁用
                    // return date.getTime() <= Date.now();    //禁用今天以及以前的日期
                }
            },
            // rules:{
            //     name:[{required: true, message: this.$t('WarrantyObject.nameRequire'),trigger:'blur'}],
            //     email:[
            //         {required: true, message:this.$t('WarrantyObject.emailRequire'),trigger:'blur'},
            //         {pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            //         message: this.$t('LoginObject.emailInvalidate'),trigger:'blur'}
            //     ],
            //     purchaseTime:[{required: true, message:this.$t('WarrantyObject.datePlaceHolder'),trigger:'blur'}],
            //     product:[{required: true, message: this.$t('WarrantyObject.productRequire'),trigger:'blur'}],
            //     purchasePlace:[{required: true, message:this.$t('WarrantyObject.palceReuqire'),trigger:'blur'}],
            //     serialCode:[{required: true, message:this.$t('WarrantyObject.codeRequire'),trigger:'blur'}],
            // },
            productOptions:[],
            warrantItemsChecked:false
        }
    },
    computed: {
        rules(){
            return{
                
                name:[{required: true, message: this.$t('WarrantyObject.nameRequire'),trigger:'blur'}],
                email:[
                    {required: true, message:this.$t('WarrantyObject.emailRequire'),trigger:'blur'},
                    {pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                    message: this.$t('LoginObject.emailInvalidate'),trigger:'blur'}
                ],
                purchaseTime:[{required: true, message:this.$t('WarrantyObject.datePlaceHolder'),trigger:'blur'}],
                product:[{required: true, message: this.$t('WarrantyObject.productRequire'),trigger:'blur'}],
                purchasePlace:[{required: true, message:this.$t('WarrantyObject.palceReuqire'),trigger:'blur'}],
                serialCode:[{required: true, message:this.$t('WarrantyObject.codeRequire'),trigger:'blur'}],
            }
        }         
    },
    activated(){
        this.$jq(window).scrollTop(0)
        this.getProductOptions()
        if(this.$refs.WarrantyFormRef){
            this.$refs.WarrantyFormRef.clearValidate()
        }
    },
    deactivated(){
        // console.log('售后。。deactivated')
        if(this.$refs.WarrantyFormRef){
            this.$refs.WarrantyFormRef.clearValidate()
        }
        
    },
    beforeDestroy(){
        this.resetForm()
    },
    methods:{
        getProductOptions(){
            this.$request.get('/user/getDictData',{dictType:'hs_device_type'},{}).then(response=>{
                // console.log('productOptions',response)
                if(response.data.code == 200){
                    let list = response.data.data
                    this.productOptions = list
                }else {
                    this.gradeOptins = []
                }
            }).catch(err=>{
                console.log(err)
                this.gradeOptins = []
            })
        },
        resetForm(){
            this.$set(this.warrantyForm,'name','')
            this.$set(this.warrantyForm,'email','')
            this.$set(this.warrantyForm,'phone','')
            this.$set(this.warrantyForm,'purchaseTime','')
            this.$set(this.warrantyForm,'product','')
            this.$set(this.warrantyForm,'purchasePlace','')
            this.$set(this.warrantyForm,'serialCode','')
        },  
        doSubmit(){
            let now = new Date().getTime()
            let last = localStorage.getItem('LAST_WARRANTY_TIME')
            if(now - last < this.detlaTime){
                this.$toastError(this.$t('CommonObject.tomuch'))
                return
            }
            let body = JSON.parse(JSON.stringify(this.warrantyForm))
            this.$request.post('/content/addWarranty',body).then(response=>{
                if(response.data.code == 200){  
                    this.$toastSuccess(this.$t('CommonObject.success'))
                    this.resetForm()
                    let n = new Date().getTime() // 毫秒
                    localStorage.setItem('LAST_WARRANTY_TIME',n)
                }else {
                    this.$toastError(this.$t('CommonObject.fail'))
                }
            }).catch(err=>{
                this.$toastError(this.$t('CommonObject.fail'))
            })
        },
        onClickSubmit(){
            if (this.warrantItemsChecked == false) {
                this.$toastError(this.$t('WarrantyObject.fail'))
                return;
            }

            if(this.$refs.WarrantyFormRef){
                this.$refs.WarrantyFormRef.validate(p=>{
                if(p){
                    this.doSubmit()
                }  
                })
            }
        },
        // 点击跳转保修条款
        onClickItems(){
            console.log('跳转保修条款')
        }
    }
}
</script>

<style scoped>
    .mm-main-container{
        
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 40px;
        background: linear-gradient(0deg, #7EBEFF 0%, #A0DCFF 100%);
    }
    .box{
        margin-top: 40px;
        padding: 24px;
        background-color: white;
        border-radius: 8px;
        box-shadow: 1px 4px 10px 1px rgba(0,0,0,0.11);
    }
    .m-title {
        color: #333333;
        font-size: 24px;
        font-weight: 600;
        text-align: center;
    }
    .m-button {
        width:200px; 
        height: 40px; 
        border-radius: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .mm-main-container /deep/ .el-form-item__label{
        
        line-height: 20px;
        display: flex;
        align-items: center;
        height: 40px;
        text-align: left;
        padding-right: 8px;
    }
    .warrantcc{
        text-decoration: underline; 
        font-weight: bold; 
        font-size: large; 
        color: blue;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/views/hanscourse/warranty/Warranty.vue